import 'slick-carousel';

( function ( $ ) {

	function initializeSlider( $block ) {
		const slickWrapper = $($block.find('.slider-wrapper'));
		const prevArrow = $block.find('.custom-prev-arrow');
		const nextArrow = $block.find('.custom-next-arrow');

		if(slickWrapper.hasClass('slick-initialized')) {
			slickWrapper.slick('unslick');
		}
		slickWrapper.slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			autoplay: true,
			autoplaySpeed: 2500,
			prevArrow: prevArrow,
			nextArrow: nextArrow,
			responsive: [
				{
					breakpoint: 768,
					settings: {
						dots: true,
						arrows: false,
					}
				},
			]
		});
	}

	// Initialize slick slider for woo-blocks
	function initializeSliderWooBlock() {
		$('.wc-block-grid__products').slick({
			infinite: true,
			slidesToShow: 5,
			responsive: [
				{
					breakpoint: 1400,
					settings: {
						slidesToShow: 5,
					}
				},
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 4,
					}
				},
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 3,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 576,
					settings: {
						slidesToShow: 1,
					}
				}
			]
		});
	}

	// Initialize each block on page load (front end)
	$(document).ready(function(){
		$( '.indy-slider' ).each(function(){
			initializeSlider( $(this) );
		});
		initializeSliderWooBlock()
	});


	// Initialize dynamic block preview (editor)
	if( window.acf ) {
		window.acf.addAction( 'render_block_preview/type=slider', initializeSlider );
	}

} )( jQuery );
